
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';

import { getImage, getData } from '../../helpers/indexedDbHelper';

import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';

function Index({dishs, setShowListProduct, top = 0}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const {  menus: menusCurrent, name: title } = dishs;


    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [menusData, setMenusData] = useState([]);
    const [menus, setMenus] = useState(menusCurrent);

    
     useEffect(() => {
                getData('menu').then((items) => {
                    const data = items.value.data;
                    setMenusData(data);
                });
     }, []);
    
    useEffect(() => {
        
    }, [menus]);
    


    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                    
                }
            });
        }, []);
        
        return (
           <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundColor: 'white', marginBottom: 30, textDecoration: 'none', 
                width: 340,
                maxHeight: 500,
                margin: '15px 0px',
                textAlign: 'left',
                paddingBottom: 40,
                position: 'relative',
                padding: 20, boxSizing: 'border-box',
                borderRadius: 20
            }}>
                <img src={image}  style={{width: '100%', height: 320, objectFit: 'cover', borderRadius: 25}}/>
                <h3 style={
                    { color: 'black', fontWeight: '900',textTransform: 'uppercase', fontSize: 27, margin: 0,  marginTop: 10, textAlign: 'left' }
                    }> {langEng ? data.name : translate(i18n.language, data.language, data.name)}</h3>
                
                <div style={{width: '70%', marginTop: 10}}>
                    <p
                        className='shor-text'
                        style={{ fontSize: 14, color: '#000', margin: 0,fontWeight: 'bold', textAlign: 'left'}}>

                        {langEng ? 
                                    `${data.regular_decription.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    data.language, 
                                    data.regular_decription, 
                                    'regular_decription'
                                )}`
                        }
                        
                        
                    </p>
                </div>

                <div style={{position: 'absolute', bottom: 20, right: 20}}>
                    <p
                    style={{color: '#c51422', fontSize: 25, fontWeight: 'bold'}}
                    >
                    {data.price > 0 && `$ ${data.price.toFixed(2)}`}
                    </p>
                </div>
                
            </div>
        );
    }

    return (
        <div style={{position: 'absolute', top, left: 0, width: '100%', height: '100%'}}>
            <LayoutContent showBack={true} showLogo={true} setShowListProduct={ () =>setShowListProduct(false) }>
                <div>
                   <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            padding: '20px 10px 100px 10px',
                            overflow: 'scroll',
                            height: 800,
                            
                        }}>
                            {menus.map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                        </div>   

                
                
                </div>
                {showDetailProduct && <DetailProduct
                dishMenu={dataDish}
                setShowDetailProduct={setShowDetailProduct}
            />}
            </LayoutContent>
        </div>
    );
}
export default Index;